export enum UniQActions {
  SEND_MESSAGE = "SEND_MESSAGE",
  SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS",
  SEND_MESSAGE_FAIL = "SEND_MESSAGE_FAIL",
  RESET_MESSAGE = "RESET_MESSAGE",
  CLEAR_MESSAGES = "CLEAR_MESSAGES",
  SET_MESSAGES = "SET_MESSAGES",
  SET_MESSAGES_SUCCESS = "SET_MESSAGES_SUCCESS",
  SET_MESSAGES_FAIL = "SET_MESSAGES_FAIL",
  RESET_MESSAGES = "RESET_MESSAGES",

  HANDLE_SETTINGS_POPOVER = "HANDLE_UNIQ_SETTINGS_POPOVER",
  SAVE_DEFAULT_PROMPT = "SAVE_DEFAULT_PROMPT",
  SAVE_DEFAULT_PROMPT_SUCCESS = "SAVE_DEFAULT_PROMPT_SUCCESS",
  SAVE_DEFAULT_PROMPT_FAIL = "SAVE_DEFAULT_PROMPT_FAIL",

  GET_DEFAULT_PROMPT = "GET_DEFAULT_PROMPT",
  GET_DEFAULT_PROMPT_SUCCESS = "GET_DEFAULT_PROMPT_SUCCESS",
  GET_DEFAULT_PROMPT_FAIL = "GET_DEFAULT_PROMPT_FAIL",
  RESET_DEFAULT_PROMPT_DATA = "RESET_DEFAULT_PROMPT_DATA",
  RESET_SESSION = "RESET_SESSION",
  RESET_SESSION_SUCCESS = "RESET_SESSION_SUCCESS",
  RESET_SESSION_FAIL = "RESET_SESSION_FAIL",
}
